import { SlabTheme } from '../../../theme';
import { ToastAlertVariants } from '../ToastContext';

export const ToastAlertColors: Record<ToastAlertVariants, string> = {
  [ToastAlertVariants.success]: SlabTheme.palette.SlabStatus.success.main,
  [ToastAlertVariants.error]: SlabTheme.palette.SlabStatus.error.main,
  [ToastAlertVariants.info]: SlabTheme.palette.SlabStatus.info.main,
};
